function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var TinyQueue = /*#__PURE__*/ function() {
    "use strict";
    function TinyQueue() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], compare = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(a, b) {
            return a < b ? -1 : a > b ? 1 : 0;
        };
        _class_call_check(this, TinyQueue);
        this.data = data;
        this.length = this.data.length;
        this.compare = compare;
        if (this.length > 0) {
            for(var i = (this.length >> 1) - 1; i >= 0; i--)this._down(i);
        }
    }
    _create_class(TinyQueue, [
        {
            key: "push",
            value: function push(item) {
                this.data.push(item);
                this._up(this.length++);
            }
        },
        {
            key: "pop",
            value: function pop() {
                if (this.length === 0) return undefined;
                var top = this.data[0];
                var bottom = this.data.pop();
                if (--this.length > 0) {
                    this.data[0] = bottom;
                    this._down(0);
                }
                return top;
            }
        },
        {
            key: "peek",
            value: function peek() {
                return this.data[0];
            }
        },
        {
            key: "_up",
            value: function _up(pos) {
                var _this = this, data = _this.data, compare = _this.compare;
                var item = data[pos];
                while(pos > 0){
                    var parent = pos - 1 >> 1;
                    var current = data[parent];
                    if (compare(item, current) >= 0) break;
                    data[pos] = current;
                    pos = parent;
                }
                data[pos] = item;
            }
        },
        {
            key: "_down",
            value: function _down(pos) {
                var _this = this, data = _this.data, compare = _this.compare;
                var halfLength = this.length >> 1;
                var item = data[pos];
                while(pos < halfLength){
                    var bestChild = (pos << 1) + 1; // initially it is the left child
                    var right = bestChild + 1;
                    if (right < this.length && compare(data[right], data[bestChild]) < 0) {
                        bestChild = right;
                    }
                    if (compare(data[bestChild], item) >= 0) break;
                    data[pos] = data[bestChild];
                    pos = bestChild;
                }
                data[pos] = item;
            }
        }
    ]);
    return TinyQueue;
}();
export { TinyQueue as default };
